<template>
	<div class="action-button-wrapper start">
      <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('backupNow')">
          <span class="icon-cont">
              <backups-icon class="icon-default backups-icon"></backups-icon>
          </span>
          <span>Backup now</span>
      </b-button>
  </div>
</template>

<script>
import BackupsIcon from '../../assets/backups.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	BackupsIcon
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
  methods:{
    emitAction(action) {
      this.$emit('action', { action: action, site: this.site });
    },
  }
};
</script>